export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=fr.loveconnectplus.saxo";

export const PACKS = [
  { id: "small", sku: "credits_pack_small", credits: 25, price: "4,99 €", label: "Starter", image: "/images/pack_small.png" },
  { id: "medium", sku: "credits_pack_medium", credits: 75, price: "9,99 €", label: "Popular", bonus: "+20%", popular: true, image: "/images/pack_medium.png" },
  { id: "large", sku: "credits_pack_large", credits: 250, price: "24,99 €", label: "Premium", bonus: "+50%", image: "/images/pack_large.png" },
];

export const PLANS = [
  { id: "weekly", sku: "premium_weekly", name: { fr: "Hebdo", en: "Weekly" }, price: "9,99 €", period: { fr: "/semaine", en: "/week" }, duration: { fr: "7 jours", en: "7 days" }, credits: 100 },
  { id: "monthly", sku: "premium_monthly", name: { fr: "Mensuel", en: "Monthly" }, price: "29,99 €", period: { fr: "/mois", en: "/month" }, duration: { fr: "30 jours", en: "30 days" }, credits: 300, popular: true },
];

export const PLAN_FEATURES = [
  { fr: "Messages illimités", en: "Unlimited messages" },
  { fr: "Messages floutés débloqués", en: "Blurred messages unlocked" },
  { fr: "Voir qui vous a liké", en: "See who liked you" },
  { fr: "Recherche IA débloquée", en: "AI Search unlocked" },
];

export const isPremiumUser = (user) => {
  const sub = user?.subscription;
  if (user?.is_admin) return true;
  if (!sub?.is_active || !sub?.expires_at) return false;
  return new Date(sub.expires_at).getTime() > Date.now();
};

// Vrai uniquement dans l'app Play Store (TWA) : jamais de paiement Mollie dedans
export const isPlayStoreApp = () => {
  try {
    if (document.referrer.startsWith("android-app://")) sessionStorage.setItem("lc_twa", "1");
    return sessionStorage.getItem("lc_twa") === "1";
  } catch {
    return false;
  }
};

// Vrai si l'app tourne installée (TWA Play Store / PWA), faux sur navigateur web
export const isInstalledApp = () => {
  try {
    if (document.referrer.startsWith("android-app://")) sessionStorage.setItem("lc_twa", "1");
    return sessionStorage.getItem("lc_twa") === "1" ||
      window.matchMedia("(display-mode: standalone)").matches ||
      window.matchMedia("(display-mode: fullscreen)").matches ||
      window.navigator.standalone === true;
  } catch {
    return false;
  }
};
